import { createFileRoute } from '@tanstack/react-router';

import { AppointmentDetailPage } from '../../portal/appointment-detail-page';

/**
 * `/account/appointments/$id` — one visit (M10.4, FR-PORTAL-02, FR-PORTAL-03).
 *
 * The id is an opaque appointment id and is the only thing in this URL. No name, no date,
 * no reason for the visit: a path is logged by proxies, kept in history and pasted into
 * chat windows, so nothing that identifies a person or their care goes in one (rules §25,
 * SECURITY.md §7).
 */
export const Route = createFileRoute('/account/appointments/$id/')({
  component: AppointmentDetailRoute,
});

function AppointmentDetailRoute() {
  const { id } = Route.useParams();
  return <AppointmentDetailPage appointmentId={id} />;
}
